const addCartUrl = catalogModule.getUrl("add_cart")
const PaypalPackageButton = (props) => {
    let productPackage = props.productPackage;
    let buttonText = props.textButton;
    return <React.Fragment>
        <form method="post" action={addCartUrl}>
            <input hidden name='csrfmiddlewaretoken' value={csrf} readOnly/>
            <input hidden name='key' value={productPackage.key} readOnly/>
            <button className="anp-button is-primary full-width">{buttonText}</button>
            { props.messageText && <div className="message-text">{ props.buttonMessage }</div> }
        </form>
    </React.Fragment>
}

export default PaypalPackageButton;
